export const DRAG_DROP_TYPES = {
  course: "course",
  content: "content",
};
